import render from '../components/render'
import stage from '../components/stage'
import gsap from 'gsap'
import ScrollToPlugin from 'gsap/ScrollToPlugin.js';
gsap.registerPlugin( ScrollToPlugin);

import Component from 'gia/Component';
import loadComponents from 'gia/loadComponents';
import removeComponents from 'gia/removeComponents';

import config from 'gia/config';
import '../components/timeout'

import Marker from './marker'
import Animation from './animation'
import Newsletter from './newsletter'

import lazySizes from 'lazysizes';
import { log } from 'handlebars';


class App {

  constructor($) {
    this.create()
  }

  create() {

      lazySizes.init()
      config.set('log', false); // disables unnecessary console.log calls

     

      $('.hamburger').on('click', (e)=>{
        $('body').toggleClass('has-menu')
      })

      $('.menu__nav').on('click', (e) => {
        $('body').removeClass('has-menu')
      })

      $('.menu__nav a').on('click', (e) => {

          const el = $(e.currentTarget).attr('href')
          var hash = Array.from(el)[0];
         if(hash == "#"){
            e.preventDefault()
         }
          
          gsap.to(window, {duration: .5, scrollTo: {y: el, offsetY: 100}});

        })

      const components = {

        Marker: Marker,
        Animation: Animation,
        Newsletter: Newsletter
      }

      loadComponents(components)
      $('body').removeClass('vm-loading').addClass('loaded')


      $('body').on('click', '.basket', (e) => {
        e.preventDefault()
        showDialog()
      })

      $('body').on('click', '.close-cart', (e) => {
       
        e.preventDefault()
        closeDialog()
      })

      $('body').on('click', '.cart-mini__bg', (e) => {
        e.preventDefault()
        closeDialog()
      })

       $('body').on('click', '.added_to_cart', (e) => {
         e.preventDefault()
         showDialog()
       })

       $('.filter').on('click', (e) => {
         e.preventDefault()

          const el = e.currentTarget.dataset.filter
          $('.filter').removeClass('active')
          $(e.currentTarget).addClass('active')

          $(`.article`).removeClass('active')
          $(`.article${el}`).addClass('active')
       })


       const showDialog = () => {
         $('.cart-mini').addClass('visible')
         
       };
       const closeDialog = () => {
         console.log('closecart')
         $('.cart-mini').removeClass('visible')
       }
      

       $(document.body).on('added_to_cart', (e) => {

         showDialog();
         console.log('added to cart');

       });


  }


}

module.exports = App
